
import { defineComponent, ref, computed, onMounted } from "vue-demi";
import { track } from "@amplitude/analytics-browser";

export default defineComponent({
  name: "Pricing",

  components: {
    TabsSlider: () => import("@/modules/Pricing/Subscription/TabsSlider.vue"),
    Subscription: () => import("@/modules/Pricing/Subscription/Subscription.vue"),
    Services: () => import("@/modules/Pricing/Services/Services.vue"),
  },

  setup() {
    const selectedTab = ref(0);

    const tabs = computed(() => [{ title: "Subscription" }, { title: "Services" }]);

    onMounted(() => {
      track("Viewed Pricing Page");
    });

    return {
      selectedTab,
      tabs,
    };
  },
});
